import { AxiosError } from "axios";
import useSWRImmutable from "swr/immutable";
import { GetYieldVault200Response } from "../../../codegen-api";
import { publicApi } from "../../../services/api/apiFetcher";
import { APIEndpointEnum } from "../../../enums/endpoint";
import { useLoggerMiddleware } from "../middleware/useLoggerMiddleware";

const YIELD_VAULT_API_ENABLED =
  process.env.REACT_APP_ENABLE_YIELD_VAULT_API === "true";

export const useYieldVault = () => {
  const publicFetcher = publicApi();

  const swr = useSWRImmutable<GetYieldVault200Response | undefined, AxiosError>(
    YIELD_VAULT_API_ENABLED ? [APIEndpointEnum.YIELD_VAULT] : undefined,
    async () => (await (await publicFetcher.getYieldVault())()).data,
    {
      use: [useLoggerMiddleware],
    }
  );

  return {
    ...swr,
  };
};
